import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import { GenericModal } from '../../../../components/common/Modal/GenericModal';
import { showErrorToast } from '../../../../components/PluginsMenu/Toastr/Toastr';

export const CreateAdminModal = ({ show, handleClose, onCreateAdmin }) => {
    const [formData, setFormData] = useState({
        email: '',
        password: '',
        firstName: '',
        lastName: '',
        role: 'admin'
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const validateForm = () => {
        if (!formData.email.trim()) {
            showErrorToast('Email is required');
            return false;
        }
        if (!formData.password || formData.password.length < 8) {
            showErrorToast('Password must be at least 8 characters long');
            return false;
        }
        if (!formData.firstName.trim()) {
            showErrorToast('First Name is required');
            return false;
        }
        if (!formData.lastName.trim()) {
            showErrorToast('Last Name is required');
            return false;
        }
        return true;
    };

    const handleSave = () => {
        if (!validateForm()) {
            return;
        }

        onCreateAdmin(formData);

        setFormData({
            email: '',
            password: '',
            firstName: '',
            lastName: '',
            role: 'admin'
        });
    };

    const roleOptions = [
        { value: 'user-management', label: 'Admin' },
        { value: 'data-entry', label: 'Super Admin' },
        { value: 'content-manager', label: 'Content Manager' },
        { value: 'finance-manager', label: 'Finance Manager' },
        { value: 'administrator', label: 'Administrator' },
    ];

    return (
        <GenericModal
            show={show}
            handleClose={handleClose}
            title="Create Admin Account"
            handleSave={handleSave}
        >
            <Form>
                <Form.Group className="mb-3">
                    <Form.Label>Email Address</Form.Label>
                    <Form.Control
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                    />
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                        type="text"
                        name="password"
                        value={formData.password}
                        onChange={handleInputChange}
                        required
                    />
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>First Name</Form.Label>
                    <Form.Control
                        type="text"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleInputChange}
                        required
                    />
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>Last Name</Form.Label>
                    <Form.Control
                        type="text"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleInputChange}
                        required
                    />
                </Form.Group>

                <Form.Group className="mb-3">
                    <Form.Label>Role</Form.Label>
                    <Form.Control
                        as="select"
                        name="role"
                        value={formData.role}
                        onChange={handleInputChange}
                    >
                        {roleOptions.map((role) => (
                            <option key={role.value} value={role.value}>
                                {role.label}
                            </option>
                        ))}
                    </Form.Control>
                </Form.Group>
            </Form>
        </GenericModal>
    );
};